import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, CardHeader } from 'reactstrap';
import { BASE_URL } from '../../../constants';
import 'react-toggle/style.css';
import Toggle from 'react-toggle';
import { FaTimes } from 'react-icons/fa';


let apiTimeoutId = null;

function EditTemplate(props) {
	const [errMsg, setErrMsg] = useState(null);
	const navigate = useNavigate();
	const { id } = useParams();
	const [bedroom, setBedroom] = useState(true);
	const [bathroom, setBathroom] = useState(true);
	const [title, setTitle] = useState('');
	const [areas, setAreas] = useState([]);

	// new amenity
	const [modalOpen, setModalOpen] = useState(false);
	const [availableItems, setAvailableItems] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);
	const [amenityTitle, setAmenityTitle] = useState('');
	const [searchQuery, setSearchQuery] = useState("");
	const [isEditAmenityIdx, setIsEditAmenityIdx] = useState(null);

	const [templateItems, setTemplateItems] = useState([]);

	useEffect(() => {
		fetchData()
		fetchAvailableItems();
	}, [])

	useEffect(() => {
		if (apiTimeoutId) clearTimeout(apiTimeoutId);

		apiTimeoutId = setTimeout(() => {
			fetchAvailableItems();
		}, 500);
	}, [searchQuery])

	const fetchData = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const template = await axios.get(`${BASE_URL}/template/specific-template/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});

			if (template.status) {
				const data = template.data.result;
				setTitle(data.title);
				setBedroom(data.has_bedroom === 1);
				setBathroom(data.has_bathroom === 1);
				setAreas(data.areas);
				setTemplateItems(data.items)
			}
			console.log('pppp', template)

		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const areaIds = areas.filter(area => area.isActive).map(area => area.id);

			const response = await axios.put(`${BASE_URL}/template/update/${id}`, {
				title: title,
				has_bedroom: bedroom,
				has_bathroom: bathroom,
				areas: areas
			}, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});

			if (response.data.status) {
				navigate('/template');
			} else {
				setErrMsg(response.data.message);
			}
		} catch (error) {
			setErrMsg('Error editing template. Please try again.');
			console.error('Error editing template:', error);
		}
	};

	const fetchAvailableItems = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const response = await axios.get(`${BASE_URL}/area/item/non-custom?q=${searchQuery}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			setAvailableItems(response.data.result);
		} catch (error) {
			console.error("Error fetching area items", error);
		}
	};

	// add new amenity
	const handleModalSubmit = () => {
		if (!amenityTitle || amenityTitle === '') {
			alert('Please enter amenity title');
			return;
		}
		if (selectedItems.length === 0) {
			alert('Please select at least one item');
			return;
		}

		const newArea = {
			title: amenityTitle,
			item_ids: [...selectedItems],
			is_common: 0,
		};

		// Add new area and update filteredAreas
		if (isEditAmenityIdx !== null) {
			const newAreas = [...areas];
			newAreas[isEditAmenityIdx] = {
				...newAreas[isEditAmenityIdx],
				...newArea
			};
			setAreas(newAreas);
			setIsEditAmenityIdx(null);
		} else {
			setAreas([...areas, newArea]);
		}

		// Reset input fields
		setAmenityTitle('');
		setSelectedItems([]);
		setModalOpen(false);
	};

	const editAmenity = (area, i) => {
		setAmenityTitle(area.title);
		setSelectedItems(area.item_ids);
		setModalOpen(true);
		setIsEditAmenityIdx(i);
	}

	const removeAmenity = (index) => {
		if (window.confirm('Are you sure you want to remove this amenity?')) {
			const newAreas = [...areas];
			newAreas.splice(index, 1);
			setAreas(newAreas);
		}
	}

	const toggleBedroom = (isChecked) => {
		if (window.confirm('Are you sure you want to change this amenity?')) {
			if (isChecked) {
				const check = areas.find(a => a.title === 'Bedroom')
	
				if (!check) {
	
					let defaultItems = [
						"Ceiling & Walls",
						"Paint & Wallpaper",
						"Doors & Door Stops",
						"Door Lock & Knobs",
						"Flooring",
						"Light & Ceiling Fans",
						"Window & Screens",
						"Window Latches",
						"Drapes/Blinds/Shutters",
						"Plug & Switches",
						"Closet Shelves & Rods",
						"Cabinets",
						"Other",
					];
	
					const newArea = {
						title: 'Bedroom',
						item_ids: [...availableItems.filter(item => defaultItems.includes(item.name)).map(item => item.id)],
						is_common: 1,
					};
					setAreas([...areas, newArea]);
				}
			}
			else {
				setAreas([...areas.filter(a => a.title != 'Bedroom')])
			}
	
			setBedroom(isChecked)
		}
	}

	const toggleBathroom = (isChecked) => {
		if (window.confirm('Are you sure you want to change this amenity?')) {
			if (isChecked) {
				const check = areas.find(a => a.title === 'Bathroom')
	
				if (!check) {
					let defaultItems = [
						"Ceiling & Walls",
						"Paint & Wallpaper",
						"Doors/Locks/Knobs/Stops",
						"Flooring",
						"Light Fixtures",
						"Window & Screens",
						"Window Latches",
						"Drapes/Blinds/Shutters",
						"Plug & Switches",
						"Closet Shelves & Rods",
						"Cabinets & Handles",
						"Countertops",
						"Sink & Faucets",
						"Toilet/Lid/Seat/Paper Hldr.",
						"Heaters & Exhaust Fans",
						"Towel Fixtures",
						"Other",
					];
	
					const newArea = {
						title: 'Bathroom',
						item_ids: [...availableItems.filter(item => defaultItems.includes(item.name)).map(item => item.id)],
						is_common: 1,
					};
					setAreas([...areas, newArea]);
				}
			}
			else {
				setAreas([...areas.filter(a => a.title != 'Bathroom')])
			}
	
			setBathroom(isChecked)
		}
	}

	console.log('areas', areas)

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<h3>Edit Template</h3>
			<Card>
				<CardBody>
					<Form onSubmit={handleSubmit}>

						<Row>
							<Col xs="6">
								<FormGroup>
									<Label for="type">Property Type</Label>
									<Input type="text" name="type" id="type" value={title} onChange={(e) => setTitle(e.target.value)} />
								</FormGroup>
							</Col>
							<Col xs="6">
								<Label>&nbsp;</Label>
								<FormGroup>
									<Label>
										<Input type="checkbox" checked={bedroom} onChange={(e) => toggleBedroom(e.target.checked)} />{' '}
										Has Bedrooms
									</Label>
								</FormGroup>

								<FormGroup>
									<Label>
										<Input type="checkbox" checked={bathroom} onChange={(e) => toggleBathroom(e.target.checked)} />{' '}
										Has Bathrooms
									</Label>
								</FormGroup>
							</Col>
						</Row>

						<div className='d-flex align-items-center gap-3 mb-2'>
							<h4 className='m-0'>Amenities</h4>
							<Button color="primary" size='sm' onClick={() => setModalOpen(true)}>+ Add Amenity</Button>
						</div>

						{areas && areas.length > 0 ? (
							<div className='d-flex justify-content-start align-items-stretch gap-4 flex-wrap'>{
								areas.map((area, i) => {
									const isBedOrBath = ['Bedroom', 'Bathroom'].includes(area.title)
									return (
									<Card key={i} style={{ background: (isBedOrBath) ? '#fff8e5' : '#f3f3f3', minWidth: 250 }}>
										<CardBody className='d-flex justify-content-between align-items-stretch' style={{ flexDirection: 'column' }}>
											<div>
												<div className='mb-2'><strong>{area.title}</strong></div>
												<FormGroup>
													<Label style={{ color: '#333' }}>
														<Input type="checkbox" checked={area.is_common} onChange={(e) => setAreas(prev => {
															const newAreas = [...prev];
															newAreas[i].is_common = e.target.checked ? 1 : 0;
															return newAreas;
														})} />{' '}
														Common Item
													</Label>
												</FormGroup>
												<ul className='p-0 ps-3 small'>
													{area.item_ids.map((itemId, j) => {
														const item = availableItems.find(item => item.id === itemId);
														if (item) {
															return (
																<li key={j}>{item.name}</li>
															);
														}

														const templateItem = templateItems.find(item => item.id === itemId);
														if (templateItem) {
															return (
																<li key={j}>{templateItem.name}</li>
															);
														}

														return null;
													})}
												</ul>
											</div>

											<div className='text-end'>
												<Button color="primary" size="sm" onClick={() => editAmenity(area, i)}>Edit</Button>
												{(!isBedOrBath) ? (
												<Button color="danger" size="sm" onClick={() => removeAmenity(i)}>Remove</Button>
												) : null}
											</div>
										</CardBody>
									</Card>
									)
								})
							}</div>
						) : (
							<div style={{ textAlign: 'center', marginLeft: '10px', color: 'gray' }}>
								No amenities added
							</div>
						)}

						<div className='text-end'>
							<Button color="primary" type="submit">Submit</Button>
						</div>
					</Form>
				</CardBody>
			</Card>


			<Modal isOpen={modalOpen} centered size="xl">
				<ModalHeader style={{ display: 'flex', justifyContent: 'space-between' }} close={
					<button className="close" onClick={() => setModalOpen(!modalOpen)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
						<FaTimes size={20} />
					</button>
				}>Add New Amenity</ModalHeader>
				<ModalBody>
					<FormGroup>
						<Label>Amenity Title</Label>
						<Input
							type="text"
							placeholder=""
							value={amenityTitle}
							onChange={(e) => setAmenityTitle(e.target.value)}
							list="amenity_titles"
						/>
						<datalist id='amenity_titles'>
							{['Exterior Items', 'Entry', 'Dining Room', 'Garage', 'Living Room', 'Kitchen & Breakfast', 'Halls', 'Family Room', 'Utility Room', 'Other'].map((item, i) => {
								return (<option key={i} value={item} />)
							})}
						</datalist>
					</FormGroup>

					<div className="mt-3">
						<Row>
							<Col>
								<h6>Selected Amenity Items:</h6>
							</Col>
						</Row>
					</div>

					<div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '20px' }}>
						{templateItems && templateItems.length > 0 ? (
							templateItems.map((item) => {
								if (!selectedItems.includes(item.id)) return;
								return (
									<div key={item.id} style={{ width: '25%', display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
										<Toggle
											checked={selectedItems.includes(item.id)}
											onChange={() => {
												if (selectedItems.includes(item.id)) {
													setSelectedItems(selectedItems.filter(selectedItem => selectedItem !== item.id));
												} else {
													setSelectedItems([...selectedItems, item.id]);
												}
											}}
											icons={false}
										/>
										<span style={{ marginLeft: '10px' }}>{item.name}</span>
									</div>
								)
							})
						) : (
							<div style={{ textAlign: 'center', marginLeft: '10px', color: 'gray' }}>
								Amenity items not found
							</div>
						)}

					</div>

					<div className="mt-3">
						<Row>
							<Col>
								<h6>Available Amenity Items:</h6>
							</Col>
							<Col className="text-end">
								<Input
									type="text"
									placeholder="Search by name"
									value={searchQuery}
									onChange={e => setSearchQuery(e.target.value)}
									style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
								/>
							</Col>
						</Row>
					</div>

					<div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '20px' }}>
						{availableItems && availableItems.length > 0 ? (
							availableItems.map((item) => (
								<div key={item.id} style={{ width: '25%', display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
									<Toggle
										checked={selectedItems.includes(item.id)}
										onChange={() => {
											if (selectedItems.includes(item.id)) {
												setSelectedItems(selectedItems.filter(selectedItem => selectedItem !== item.id));
											} else {
												setSelectedItems([...selectedItems, item.id]);
											}
										}}
										icons={false}
									/>
									<span style={{ marginLeft: '10px' }}>{item.name}</span>
								</div>
							))
						) : (
							<div style={{ textAlign: 'center', marginLeft: '10px', color: 'gray' }}>
								Amenity items not found
							</div>
						)}

					</div>

				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={() => setModalOpen(false)}>Cancel</Button>
					<Button color="primary" onClick={handleModalSubmit}>Add Amenity</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
}

export default EditTemplate;
